import React, { Component } from 'react';

import style from './feedback.module.scss';
import { Button } from '../components/button';
import { Spinner } from '../components/spinner';
import { UserContext } from '../context/UserContext';
import { sendFeedback } from '../api/feedback';
import { ContentPage } from '../components/contentpage';

class FeedbackPage extends Component {
  constructor(props) {
    super(props);

    const { user = {} } = props;
    const { email, username } = user;

    this.state = {
      subject: '',
      text: '',
      email,
      name: username,
      error: null,
      isSending: false,
      success: false
    };
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    this.setState({ error: null, isSending: true });
    sendFeedback({
      subject: this.state.subject,
      text: this.state.text,
      email: this.state.email,
      name: this.state.name
    })
      .then(([_, err]) => {
        if (err) {
          return this.setState({ isSending: false, success: false, error: err.message });
        }

        this.setState({ success: true, isSending: false, error: null });
      })
      .catch(e => {
        console.error(e);

        this.setState({
          isSending: false,
          success: false,
          error: 'Something unexpected happened!'
        });
      });
  };

  render() {
    const { subject, text, email, name, error, isSending, success } = this.state;
    const isLoggedIn = this.props.user && this.props.user.loggedIn === true;

    return (
      <ContentPage>
        <div className={style.feedback}>
          <h2>Feedback</h2>
          {success ? (
            <p>Danke für Ihr Feedback!</p>
          ) : (
            <form onSubmit={this.onSubmit}>
              <div className={style.feedbackGroup}>
                <label>
                  <span>Betreff*</span>
                  <input
                    required
                    placeholder="Betreff"
                    type="text"
                    name="subject"
                    value={subject}
                    onChange={this.onChange}
                  />
                </label>
                <br />
                <label>
                  <span>Name*</span>
                  <input
                    required
                    placeholder="Ingrid Maier"
                    type="text"
                    name="name"
                    value={name}
                    onChange={this.onChange}
                  />
                </label>
                <br />
                <label>
                  <span>Email{isLoggedIn ? `: ${email}` : '*'}</span>
                  <input
                    required
                    placeholder="Ingrid@Maier.de"
                    type={isLoggedIn ? 'hidden' : 'email'}
                    name="email"
                    value={email}
                    onChange={this.onChange}
                  />
                </label>
                <br />
                <label>
                  <span>Nachricht*</span>
                  <textarea required name="text" value={text} onChange={this.onChange} />
                </label>
                <br />

                {error && <div className="formHint">{error}</div>}
              </div>
              <div>
                <Button type="submit" modifier={isSending && 'loading'} disabled={isSending}>
                  {isSending && <Spinner />}
                  Absenden
                </Button>
              </div>
            </form>
          )}
        </div>
      </ContentPage>
    );
  }
}

const userDataToProps = props => {
  return (
    <UserContext.Consumer>
      {data => {
        if (data.loading) {
          return <Spinner modifier={'dark'} />;
        }
        return <FeedbackPage {...props} user={data} />;
      }}
    </UserContext.Consumer>
  );
};

export default userDataToProps;
